import { useTranslation } from "react-i18next";

interface LoaderProps {
  message?: string;
}

export default function Loader({ message }: LoaderProps) {
  const { t } = useTranslation();
  const displayMessage = message || t("common.loading");

  return (
    <div className="flex justify-center items-center h-64">
      <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-blue-500" />
      <p className="ml-4 text-lg text-gray-600">{displayMessage}</p>
    </div>
  );
}
